/** Microsoft azure variable */
export const INSURER_DEFAULT_ID = 'default_insurer';
